import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import styles from "./Navbar.module.scss";
import logo from "./assets/navbar-logo.png";
import { Link } from "react-router-dom";
import Burger from "@animated-burgers/burger-squeeze";
import "@animated-burgers/burger-squeeze/dist/styles.css";

const Navbar = () => {
  const [navStatus, setNavStatus] = useState(false);
  const location = useLocation();
  const activePath = location.pathname;
  const toggleMobileNavigation = () => setNavStatus(!navStatus);

  return (
    <nav className={styles.navbar}>
      <div className={styles.navContainer}>
        <Link to="/" style={{width: '100%'}}>
          <div className={styles.navLogo}>
            <img src={logo} alt="logo" />
            <h1>Ateneo Commission on Election</h1>
          </div>
        </Link>

        <div className={styles.navBurger}>
          <Burger onClick={toggleMobileNavigation} isOpen={navStatus} />
        </div>

        <div className={styles.navMenu}>
          <ul className={styles.navItems}>
            <li className={styles.navItem}>
              <Link to="/" className={styles.navLink}>
                Home
              </Link>
              {activePath === "/" && <div className={styles.line}></div>}
            </li>
            <li className={styles.navItem}>
              <Link to="/candidacy-submission" className={styles.navLink}>
                Candidacy
              </Link>
              {activePath === "/candidacy-submission" && (
                <div className={styles.line}></div>
              )}
            </li>
            <li className={styles.navItem}>
              <Link to="/memorandums" className={styles.navLink}>
                Announcements
              </Link>
              {activePath === "/memorandums" && (
                <div className={styles.line}></div>
              )}
            </li>
          </ul>
        </div>

        <div className={styles.navBtnWrapper}>
          <button className={styles.navBtn}>
            <Link to="/" className={styles.navBtnLink}>
              Apply
            </Link>
          </button>
        </div>
      </div>

      {navStatus && (
        <ul className={styles.navMobile}>
          <li className={styles.navItem}>
            <Link
              to="/"
              className={styles.navLink}
              onClick={toggleMobileNavigation}
            >
              Home
            </Link>
          </li>
          <li className={styles.navItem}>
            <Link
              to="/candidacy-submission"
              className={styles.navLink}
              onClick={toggleMobileNavigation}
            >
              Candidacy
            </Link>
          </li>
          <li className={styles.navItem}>
            <Link
              to="/memorandums"
              className={styles.navLink}
              onClick={toggleMobileNavigation}
            >
              Announcements
            </Link>
          </li>
          <li className={styles.navItem}>
            <Link
              to="/"
              className={styles.navLink}
              style={{ fontWeight: "600" }}
              onClick={toggleMobileNavigation}
            >
              Apply
            </Link>
          </li>
        </ul>
      )}
    </nav>
  );
};

export default Navbar;
